import React, { useEffect, useState } from 'react';
import Header from '../../NavMenuBar/Header';
import loader from "../../../assets/Images/loder.gif";
import PXServices from "../../../Services/px-settings.service";
import { FormFieldError } from '../../../shared/components/FormFieldError';
import { toast } from 'react-toastify';

const OrganizationSettings = () => {

    const [id, setId] = useState('');
    const [title, setTitle] = useState('');
    const [subtitle, setSubtitle] = useState('');
    const [disclaimerOne, setDisclaimerOne] = useState('');
    const [disclaimerTwo, setDisclaimerTwo] = useState('');
    const [assistanceMessage, setAssistanceMessage] = useState('');


    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isUpdateEnabled, setIsUpdateEnabled] = useState(false);

    const [error, setError] = useState('');

    useEffect(() => {
        getDefaultText();
    }, []);

    const getDefaultText = async () => {
        try {
            const response = await PXServices.getDefaultText();
            console.log(response.data.pxTitle);
            if (response.status === 200) {
                setId(response.data._id);
                setTitle(response.data.pxTitle);
                setSubtitle(response.data.pxSubtitle);
                setDisclaimerOne(response.data.disclaimerOne);
                setDisclaimerTwo(response.data.disclaimerTwo);
                setAssistanceMessage(response.data.assistanceMessage);
            } else {
                toast.error("Couldn't fetch default text");
            }
        } catch (err) {
            console.log(err);
            toast.error("Couldn't fetch default text");
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (title === '' || subtitle === '') {
            setError('All fields are required');
            return;
        }
        setError('');
        await updateDefaultText(
            {
                _id: id,
                pxTitle: title,
                pxSubtitle: subtitle,
                disclaimerOne: disclaimerOne,
                disclaimerTwo: disclaimerTwo,
                assistanceMessage: assistanceMessage
            });
    }

    async function updateDefaultText(data) {
        setIsSubmitting(true);
        try {
            const response = await PXServices.updateDefaultText(data);
            await getDefaultText();

            if (response.status === 200) {
                toast.success("Successfully updated default text");
                setIsSubmitting(false);
                setIsUpdateEnabled(false);
                return;
            }
            toast.error("Couldn't create default text");
        } catch (err) {
            console.log(err);
            toast.error("Couldn't create default text");
            setIsSubmitting(false);
            setIsUpdateEnabled(false);
        }
    }

    const cancelUpdate = () => {
        setIsUpdateEnabled(false);
        setError('');
        getDefaultText();
    }

    return (
        <main class="page-content bg-light">
            <Header main_title="Admin Setting" title="Organization Settings" />
            <div class="container-fluid">
                <div class="layout-specing">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card border-0 shadow rounded p-3">
                                <h4 class="mb-0">Organization Settings</h4>
                                <form class="" onSubmit={handleSubmit}>
                                    <div className="mb-4 col-md-5">
                                        <label className="cstm-label">Patient Web App Title</label>
                                        <input
                                            type="text"
                                            className="cstm-input"
                                            placeholder="Text to be displayed in the header"
                                            disabled={!isUpdateEnabled}
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-4 col-md-5">
                                        <label className="cstm-label">Patient Web App Subtitle</label>
                                        <input
                                            type="text"
                                            className="cstm-input"
                                            placeholder="Text to be displayed in the sub-header"
                                            disabled={!isUpdateEnabled}
                                            value={subtitle}
                                            onChange={(e) => setSubtitle(e.target.value)}
                                        />
                                        <FormFieldError message={error} />
                                    </div>

                                    <div className="mb-4 col-md-5">
                                        <label className="cstm-label">Thankyou Disclaimer One</label>
                                        <input
                                            type="text"
                                            className="cstm-input"
                                            placeholder="Text to be displayed in your thank you page"
                                            disabled={!isUpdateEnabled}
                                            value={disclaimerOne}
                                            onChange={(e) => setDisclaimerOne(e.target.value)}
                                        />
                                        <FormFieldError message={error} />
                                    </div>

                                    <div className="mb-4 col-md-5">
                                        <label className="cstm-label">Thankyou Disclaimer Two</label>
                                        <input
                                            type="text"
                                            className="cstm-input"
                                            placeholder="Text to be displayed in the landing page"
                                            disabled={!isUpdateEnabled}
                                            value={disclaimerTwo}
                                            onChange={(e) => setDisclaimerTwo(e.target.value)}
                                        />
                                        <FormFieldError message={error} />
                                    </div>

                                    <div className="mb-4 col-md-5">
                                        <label className="cstm-label">Contact us message</label>
                                        <input
                                            type="text"
                                            className="cstm-input"
                                            placeholder="Text to be displayed in the footer"
                                            disabled={!isUpdateEnabled}
                                            value={assistanceMessage}
                                            onChange={(e) => setAssistanceMessage(e.target.value)}
                                        />
                                        <FormFieldError message={error} />
                                    </div>

                                    {!isUpdateEnabled &&
                                        <button
                                            type="button"
                                            className="btn-submit-login-form cstm-submitbutton btn-disable"
                                            onClick={() => setIsUpdateEnabled(true)}
                                        >

                                            Edit
                                        </button>}
                                    {isUpdateEnabled && <>
                                        <div className="submit-btnMain cstm-loader">
                                            <button type="submit"
                                                className="btn-submit-login-form cstm-submitbutton btn-disable me-2"
                                                disabled={isSubmitting}
                                            >
                                                Save
                                            </button>
                                            {isSubmitting && (
                                                <div id="login-loader" className='loader-main'>
                                                    <img src={loader} alt="" />
                                                </div>
                                            )}
                                        </div>
                                        <button type="button"
                                            className="btn-submit-login-form cstm-submitbutton btn-disable"
                                            disabled={isSubmitting}
                                            onClick={cancelUpdate}>
                                            Cancel
                                        </button>
                                    </>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default OrganizationSettings;